import { service } from '../../../../helpers/http'

export const ActionIndexOccupationSettings = ({ dispatch }, payload) => {
    return service({
        module: 'roomAllocation',
        action: 'indexOccupationSettings',
        payload: payload
    })
}

export const ActionShowOccupationSettings = ({ dispatch }, payload) => {
    return service({
        module: 'roomAllocation',
        action: 'showOccupationSettings',
        payload: payload
    })
}

export const ActionCreateOccupationSettings = ({ dispatch }, payload) => {
    return service({
        module: 'roomAllocation',
        action: 'createOccupationSettings',
        payload: payload
    })
}

export const ActionUpdateOccupationSettings = ({ dispatch }, payload) => {
    return service({
        module: 'roomAllocation',
        action: 'updateOccupationSettings',
        payload: payload
    })
}
